import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "TopBar" }
const _hoisted_2 = { slot: "start" }
const _hoisted_3 = { class: "ui-btn_label" }
const _hoisted_4 = {
  key: 0,
  class: "TopBar_pageTitle ui-txt-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_language_switch = _resolveComponent("language-switch")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isReservationPage || _ctx.isAdminPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
                class: "TopBar_back ui-btn is-sm"
              }, [
                _createVNode(_component_ion_icon, { src: _ctx.chevronBackOutline }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('ReservationPage.goBack')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "TopBar_appTitle",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: "/assets/logo/app-logo6.png",
                  class: "TopBar_appLogo"
                }, null, -1),
                _createElementVNode("span", { class: "TopBar_appName" }, "Park.it", -1)
              ]))]))
        ]),
        _createVNode(_component_ion_title, {
          size: "medium",
          slot: "start",
          class: "TopBar_title"
        }, {
          default: _withCtx(() => [
            (_ctx.isReservationPage)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
                  (_ctx.isCreatingReservation)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('TopBar.newReservation')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('TopBar.yourReservation')), 1)
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_buttons, { slot: "end" }, {
          default: _withCtx(() => [
            _createVNode(_component_language_switch, { class: "TopBar_LanguageSwitch" }),
            _createVNode(_component_ion_icon, {
              class: "TopBar_drawerIcon",
              icon: _ctx.menu,
              onClick: _ctx.handleOpenMenuClick
            }, null, 8, ["icon", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}